// We also assign hover, focus, active classes to elements
import type { css } from 'styled-components';

// like buttons so that we can get VQA for these states.
export const whenHovered = `&.hover, &:hover`;
export const whenFocused = `&.focus, &:focus-visible`;
/** @deprecated use whenPressed instead. */
export const whenActive = `&.active, &:active`;
export const whenPressed = `&.active, &:active`;
export const whenDisabled = `&:disabled, &[disabled]`;
export const withReducedMotion = (styles: string | ReturnType<typeof css>) => `
  @media (prefers-reduced-motion) {
    ${styles}
  }

  &.reduced-motion {
    ${styles}
  }
`;
